__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "HCIDWebsite";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("next/dynamic", "13.5.8", function() { return __webpack_require__.e(4953).then(function() { return function() { return __webpack_require__(14953); }; }); });
			register("next/head", "13.5.8", function() { return __webpack_require__.e(3368).then(function() { return function() { return __webpack_require__(13368); }; }); });
			register("next/image", "13.5.8", function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(8772), __webpack_require__.e(6708)]).then(function() { return function() { return __webpack_require__(29965); }; }); });
			register("next/link", "13.5.8", function() { return Promise.all([__webpack_require__.e(6901), __webpack_require__.e(1106)]).then(function() { return function() { return __webpack_require__(91106); }; }); });
			register("next/router", "13.5.8", function() { return Promise.all([__webpack_require__.e(6901), __webpack_require__.e(9044), __webpack_require__.e(6715), __webpack_require__.e(8772)]).then(function() { return function() { return __webpack_require__(86715); }; }); });
			register("next/script", "13.5.8", function() { return Promise.all([__webpack_require__.e(9044), __webpack_require__.e(8772), __webpack_require__.e(771)]).then(function() { return function() { return __webpack_require__(28133); }; }); });
			register("react-dom/client", "18.3.1", function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(4480)]).then(function() { return function() { return __webpack_require__(5338); }; }); });
			register("react-dom", "18.3.1", function() { return function() { return __webpack_require__(40961); }; }, 1);
			register("react/jsx-runtime", "18.3.1", function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(2346)]).then(function() { return function() { return __webpack_require__(74848); }; }); });
			register("react", "18.3.1", function() { return function() { return __webpack_require__(96540); }; }, 1);
			register("styled-jsx/style", "5.1.1", function() { return Promise.all([__webpack_require__.e(9710), __webpack_require__.e(5065)]).then(function() { return function() { return __webpack_require__(15065); }; }); });
			register("styled-jsx", "5.1.1", function() { return Promise.all([__webpack_require__.e(9710), __webpack_require__.e(9320)]).then(function() { return function() { return __webpack_require__(79320); }; }); });
			initExternal(71763);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};